import { Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { lazyRetry as lazy } from '@/lib/lazyRetry';
import { useAuth } from '@/contexts/AuthContext';

const VelaPage = lazy(() => import('@/pages/VelaPage'));
const ConciergePage = lazy(() => import('@/pages/ConciergePage'));
const VelaOnboardingPage = lazy(() => import('@/pages/VelaOnboardingPage'));
const OnboardingPage = lazy(() => import('@/pages/OnboardingPage'));

// Vela is live for every account (`user.vela_enabled`, false only when an account is explicitly switched off).
export const useVelaEnabled = () => {
  const { user } = useAuth();
  return !!user?.vela_enabled;
};

// `/home`: Vela's home; the classic Veluro Chat home stays at /chat (and here for accounts with Vela switched off).
export const HomeRoute = () => {
  const enabled = useVelaEnabled();
  return <Suspense fallback={null}>{enabled ? <VelaPage tab="home" /> : <ConciergePage />}</Suspense>;
};

export const VelaRoute = () => {
  const enabled = useVelaEnabled();
  if (!enabled) return <Navigate to="/home" replace />;
  return <Suspense fallback={null}><VelaPage /></Suspense>;
};

// `/onboarding`: Vela's concierge onboarding; the classic flow only for accounts with Vela switched off.
export const OnboardingRoute = () => {
  const enabled = useVelaEnabled();
  return <Suspense fallback={null}>{enabled ? <VelaOnboardingPage /> : <OnboardingPage />}</Suspense>;
};

// `/vela/setup`: (re)run the concierge setup for the active business (`?ws=` picks another).
export const VelaSetupRoute = () => {
  const enabled = useVelaEnabled();
  if (!enabled) return <Navigate to="/home" replace />;
  return <Suspense fallback={null}><VelaOnboardingPage /></Suspense>;
};
